export default "__VITE_ASSET__Bzcl2fTT__"